import { render, staticRenderFns } from "./VmTreeTypeEdit.vue?vue&type=template&id=0952e925&scoped=true&"
import script from "./VmTreeTypeEdit.vue?vue&type=script&lang=js&"
export * from "./VmTreeTypeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0952e925",
  null
  
)

export default component.exports